import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";

export function useUserProfile() {
  const value = useContext(UserContext);

  return value;
}
